import React from 'react'
import ReactDOM from 'react-dom'
import WidgetApp from 'WidgetApp'
import RichCtaApp from './App'

ReactDOM.render(
  <WidgetApp>
    <RichCtaApp />
  </WidgetApp>,
  document.getElementById('root'),
)
